<div class="chart-wrapper">
  <h4 class="chart-header">{{name}}</h4>
  <div class="horizontal-chart__content">
    <app-chart-render [config]="config" [name]="name" [data]="data" [labels]="labels" [scale]="scale" class="charts"></app-chart-render>
  </div>
</div>